import { DIMMERS_WITH_CALIBRATION, PRO_DIMMERS_WITH_CALIBRATION } from 'src/constants';

//function that checks if the device is a dimmer with calibration feature
export default function isDimmerWithCalibration(deviceType: string): boolean {
	// Check if it's a pro dimmer or a standard dimmer with calibration
	return (
		PRO_DIMMERS_WITH_CALIBRATION.includes(deviceType) ||
		DIMMERS_WITH_CALIBRATION.includes(deviceType)
	);
}
